import useCustomFieldsResource from "./useCustomFieldsResource";

const useCustomFieldsCapability = ({
  teamId,
  generation = 0,
  retainOnFocus = false,
  revalidateOnFocus = true,
}) => {
  const resource = useCustomFieldsResource({
    teamId,
    generation,
    retainOnFocus,
    revalidateOnFocus,
    path: "/custom_fields/capability",
  });
  const allowed = ["displayed", "upgrade_cta", "not_displayed"];
  const variant = allowed.includes(resource.data?.variant)
    ? resource.data.variant
    : null;
  return {
    ...resource,
    variant,
  };
};

export default useCustomFieldsCapability;
